// @ts-ignore
const fr = {
  locale: "fr",
  messages: {
    common: {
      required: "{field} est obligatoire",
      pattern: "{field} est invalide",
      min: "{field} doit être supérieur(e) 0",
      maxLength: "≤ {length} caractères",
    },
    toast: {
      errors: {
        wrongCreds: "Identifiants invalides.",
        errorOccured: "Une erreur est survenue. Merci d'essayer à nouveau.",
        errorOccuredContactSupport:
          "Une erreur est survenue. Merci d'essayer à nouveau. Si le problème persiste contactez le support.",
        authRequired: "Authentification requise.",
        access:
          "Vous n'avez pas les droits requis afin d'accèder à cette page.",
        sessionExpired: "Session expirée, merci de vous connecter à nouveau.",
        displays: {
          resource:
            "Vous n'avez pas les droits requis afin d'accéder aux panneaux",
          action:
            "Vous n'avez pas les droits requis afin de modifier les panneaux",
        },
        sectors: {
          resource:
            "Vous n'avez pas les droits requis afin d'accéder aux secteurs",
          action:
            "Vous n'avez pas les droits requis afin de modifier les secteurs",
        },
        alerts: {
          manageOutputs:
            "Vous n'avez pas les droits requis afin de gérer les notifications d'alertes",
        },
      },
      info: {
        emailWithInfoToSetPwd:
          "Un e-mail contenant les détails pour redéfinir votre mot de passe vient de vous être envoyé",
        pwdUpdated: "Mot de passe mis à jour",
        unavailable: "Non disponible",
      },
      success: {
        updateSectorSuccess: "Secteur mis à jour avec succès",
        updateDisplaySuccess: "Panneau mis à jour avec succès",
        spaceLocked:
          "Verouillage de la place demandée avec succès. Veuillez recharger les données pour voir les changements, cela peut prendre quelques instants.",
        spaceUnlocked:
          "Déverouillage de la place demandée avec succès. Veuillez recharger les données pour voir les changements, cela peut prendre quelques instants.",
        manageAlertOutputsSuccess:
          "Vos préférences ont été enregistrées avec succès",
      },
    },
    components: {
      queueComparisonTable: {
        title: "Files d'attente",
        nbPeople: "Nb personnes",
        waitingTime: "Temps d'attente",
        historically: "Historiquement",
        threeMonthsTooltip:
          "Calcul réalisé par rapport au temps d'attente à la même heure<br> et le même jour de la semaine sur les 3 derniers mois.",
        zone: "Zone",
      },
      selectInput: {
        noOptions: "Pas d'options",
      },
      selectALayerInfo: {
        selectAll: "(sélectionner tout)",
        unselectAll: "(déselectionner tout)",
        selectALayer: "Veuillez sélectionner un ou plusieurs élément(s)",
        areas: "Zones",
        points: "Points",
        paths: "Temps de parcours",
        pathsTraffic: "Zone de trafic",
      },
      floorsButton: {
        floorUnderground1: "Étage -1",
        floorUnderground2: "Étage -2",
        floorUnderground3: "Étage -3",
        floorUnderground4: "Étage -4",
        floorUnderground5: "Étage -5",
        floorUnderground6: "Étage -6",
        floorUnderground7: "Étage -7",
        floor0: "RDC",
        floor1: "1er étage",
        floor2: "2ème étage",
        floor3: "3ème étage",
        floor4: "4ème étage",
        floor5: "5ème étage",
        floor6: "6ème étage",
        floor7: "7ème étage",
        levelUnderground1: "Niveau -1",
        levelUnderground2: "Niveau -2",
        levelUnderground3: "Niveau -3",
        levelUnderground4: "Niveau -4",
        levelUnderground5: "Niveau -5",
        levelUnderground6: "Niveau -6",
        levelUnderground7: "Niveau -7",
        level0: "Niveau 0",
        level1: "Niveau 1",
        level2: "Niveau 2",
        level3: "Niveau 3",
        level4: "Niveau 4",
        level5: "Niveau 5",
        level6: "Niveau 6",
        level7: "Niveau 7",
      },
      mapCheckboxContainer: {
        aisles: "Afficher le nombre de places",
        labels: "Afficher les libellés",
        displays: "Afficher les panneaux",
        spaceLabels: "Afficher les libellés des places",
      },
      timeSlider: {
        day: "j",
        hour: "h",
        minute: "m",
        second: "s",
        mins: "min",
        seconds: "secs",
        days: "Jours :",
        hours: "Heures :",
        minutes: "Minutes :",
        floatingLabel: "Temps maximum de stationnement (en min)",
        title: "Temps limite de stationnement",
        clickToChange: "Cliquez afin de sélectionner un temps",
      },
      selectedLayersSection: {
        hide: "Masquer",
        see: "Voir l'ensemble des éléments",
        selectAllLayers: {
          one: "Sélectionner l'élément",
          other: "Sélectionner l'ensemble des éléments",
        },
        unselectAllLayers: {
          one: "Désélectionner l'élément",
          other: "Désélectionner l'ensemble des éléments",
        },
        batchUpdateUsers: {
          one: "{totalUpdated} utilisateur mis à jour avec succès",
          other: "{totalUpdated} utilisateurs mis à jour avec succès",
        },
      },
      buttons: {
        ok: "Ok",
        cancel: "Annuler",
        search: "Rechercher",
        close: "fermer",
        actualize: "Actualiser",
        backToLive: "Retour au direct",
        live: "Live",
        liveCheckbox:
          "Si cochée, Rafraichissement de la page automatique toutes les 10 secondes",
        keyNumbers: "Chiffres clés",
      },
      table: {
        labelRowsPerPage: "Lignes par page:",
        labelDisplayedRows: "{from}-{to} sur {count}",
        trier: "Trier",
        anyResult: "Aucun résultat",
      },
      pdfViewer: {
        selectApdf: "Veuillez sélectionner un rapport",
      },
      mobileAppAlert: {
        title: "Découvrez la version mobile",
      },
      map: {
        selectLayers: "Zone(s)",
      },
      placeholder: {
        customMessage:
          "Le temps de chargement est long, mais cela vaut la peine d'attendre.",
      },
      downloadGraph: {
        imgTooltip: "Sauvegarder l'image du graphique",
        csvTooltip: "Sauvegarder les données du graphique (CSV)",
      },
    },
    calendar: {
      byFiveMin: "Par 5min",
      byHour: "Par heure",
      byDay: "Par jour",
      day: "Jour",
      week: "Semaine",
      shortWeek: "Sem.",
      month: "Mois",
      the: "Le",
      at: "à",
      over24: "sur 24h",
    },
    daysOfWeek: {
      0: "Lundi",
      1: "Mardi",
      2: "Mercredi",
      3: "Jeudi",
      4: "Vendredi",
      5: "Samedi",
      6: "Dimanche",
    },
    monthsOfYear: {
      "01": "Janvier",
      "02": "Février",
      "03": "Mars",
      "04": "Avril",
      "05": "Mai",
      "06": "Juin",
      "07": "Juillet",
      "08": "Août",
      "09": "Septembre",
      10: "Octobre",
      11: "Novembre",
      12: "Décembre",
    },
    header: {
      tabs: {
        analysis: "Analyses",
        custom_analysis: "Analyse personnalisée",
        flow: "Flux",
        indicators: "Indicateurs",
        live: "Live",
        login: "Connexion",
        non_moving_cars: "Contrôles",
        park_stats: "Stationnement",
        pedestrian_stats: "Visiteurs",
        visitor_characteristics: "Qualification",
        config: "Configuration",
        config_sectors: "Secteurs",
        displays: "Panneaux",
        alerts: "Alertes",
        gates: "Points d'accès",
      },
    },
    missingPermissionsScene: {
      description:
        "Désolé, vous n'avez pas les bonnes permissions pour accéder la page demandée.",
      home: "Aller à l'accueil",
    },
    loginScene: {
      rocket: {
        firstPartTitle: "RÉVEILLEZ LA PUISSANCE",
        secondPartTitle: "DES DONNÉES DE VOTRE MOBILITÉ !",
      },
      login: {
        logoLoginLabel: "Ravi de vous revoir, connectez-vous",
        logoForgotPwdLabel: "",
        buttonLabel: "Connectez-vous",
        userNameEmail: "Email",
        password: "Mot de passe",
        keepLoggedIn: "Rester connecté(e)",
        forgotPassword: "Mot de passe oublié",
        ssoLabel: "SSO",
        ssoLoginLabel: "Connexion en cours...",
        ssoLoginModalTitle: "Connexion avec un SSO",
        ssoLoginModalDescription:
          "Pour vous connecter avec un SSO, veuillez cliquer sur le bouton correspondant à votre organisation.",
        ssoLoginButton: {
          chalonsEnChampagne: "Châlons-en-Champagne",
        },
      },
      forgotPassword: {
        validateForgotPassword: "Valider",
        cancelForgotPassword: "Annuler",
      },
      updatePassword: {
        infos:
          "Veuillez renseigner votre nouveau mot de passe pour accéder à l'application.",
        labelPassword: "Mot de passe",
      },
    },
    area: {
      type: {
        unknown: "-",
        normal: "Régulier",
        paying: "Payant",
        time_limited: "Zone bleue",
        delivery: "Livraison",
        forbidden: "Interdit",
        prm: "PMR",
        free: "Gratuit",
        street_access: "Accès route",
        carsharing: "Covoiturage",
        chargin_station: "Borne de recharge",
        drop_off: "Dépose minute",
        cash_transport: "Transport de fonds",
        taxi: "Taxi",
        drive_pickup: "Point de retrait",
        drive_pickup_large: "Point de retrait large",
        drive_queue: "File d'attente",
        service: "Service",
      },
    },
    parkStatisticsScene: {
      anyResultInArea: "Aucun résultat dans cette zone.",
      recenterOnZone: "Recentrer sur la zone",
      filters: {
        label: "Type de stationnement",
      },
      sections: {
        general: "Statistiques générales",
        controls: "Contrôles",
        graph: "Pics d'affluence réels & prévisionnels",
      },
      statsRow: {
        nbSpotsLabel: "Nombre de places",
        keyNumbersLabel: "Chiffres clés",
        nbInfractionsLabel: "Nombre d'infractions ",
        availableSpots:
          "{count, plural, one {Place libre} other {Places libres}}",
        avgParkingDuration: "Durée médiane",
        flow: "Flux",
        parkingPressure: "Tension du stationnement",
        parkedCarsLabel:
          "{count, plural, one {Véhicule stationné} other {Véhicules stationnés}}",
        infractions:
          "{count, plural, one {Véhicule} other {Véhicules}} en dépassement de temps",
        obstructiveParking:
          "{count, plural, one {Véhicule génant} other {Véhicules génants}}",
        nonMoving:
          "{count, plural, one {Véhicule ventouse} other {Véhicules ventouses}}",
        insideZone: "dans la zone",
        duringCurrentHour: "dans l'heure",
        infos: {
          parkedCars:
            "Calcul réalisé par rapport à la moyenne du nombre de véhicules stationnés<br>à la même heure et le même jour de la semaine sur les 3 derniers mois.",
          availableSpots:
            "Calcul réalisé par rapport à la moyenne du nombre de places disponibles<br>à la même heure et le même jour de la semaine sur les 3 derniers mois.",
          avgParkingDuration:
            "Calcul réalisé par rapport à la médiane du temps de stationnement des véhicules<br>à la même heure et le même jour de la semaine sur les 3 derniers mois.",
          flow: "Flux de stationnement.",
          infractions:
            "Tout véhicule stationné sur un emplacement à durée limitée est défini comme véhicule en infraction.",
          obstructiveParking:
            "Tout véhicule stationné sur un emplacement interdit (sortie de parking etc...)",
          nonMoving:
            "Tout véhicule stationné plus longtemps que la limite autorisée dans la commune avant d'être considéré comme véhicule ventouse.",
        },
      },
      chart: {
        capacity: "Capacité",
        realTime: "Temps réel",
        previsional: "Prévisionnel",
        cars: "véhicules",
        car: "véhicule",
        any: "aucun",
        tooltipTitlePrefix: "À :",
      },
      map: {
        popup: {
          park: "Stationnement",
          arrival: "Arrivée le",
          leaving: "Départ le",
          stillParked: "Véhicule encore stationné",
          stillAvailable: "Place toujours disponible",
          duration: "Durée de stationnement :",
          spotDuration: "Disponible depuis",
          spotTotalDuration: "",
          totalDurationDuring: "Stationné pendant",
          totalDurationSince: "Stationné depuis",
          spotTotalDurationDuring: "Disponible pendant",
          spotTotalDurationSince: "Disponible depuis",
          size: "Taille :",
          since: "Depuis le",
          availableTo: "Disponible jusqu'au",
          type: "Type :",
          lock: "Verrouiller",
          unlock: "Déverrouiller",
          locked: "Verrouillé le",
          lockedDuration: "Verrouillé depuis",
        },
        reloadStatsOnZone: "Recharger les données sur la zone",
        allStats: "Statistiques globales du site",
      },
    },
    pedestrianStatisticsScene: {
      anyResultInArea: "Aucun résultat dans cette zone.",
      recenterOnZone: "Recentrer sur la zone",
      sections: {
        graph: "Pics d'affluence réels & prévisionnels",
        attendance: "Affluence",
        byHour: "par heure",
        byFiveMinutes: "par 5min",
        distribution: "Répartition files d'attente",
        queueGraph: "Temps d'attente",
        queueAttendanceMaxGraph:
          "Pics d'affluence réels {count, plural, one {& prévisionnels de la file d'attente} other {des files d'attente}}",
        queueAttendanceGraph:
          "Nombre de comptages {count, plural, one {de la file d'attente} other {des files d'attente}}",
        queueWaitingDailyTimeGraph: "Temps d'attente",
      },
      statsRow: {
        keyNumbersLabel: "Chiffres clés",
        flow: "Flux",
        insideZone: "dans la zone",
        duringCurrentHour: "dans l'heure",
        visitorsLabel: "{count, plural, one {Visiteur} other {Visiteurs}}",
        infos: {
          visitors:
            "Calcul réalisé par rapport à la moyenne du nombre de visiteurs<br>à la même heure et le même jour de la semaine sur les 3 derniers mois.",
          flow: "Flux de visiteurs.",
        },
      },
      chart: {
        realTime: "Temps réel",
        previsional: "Prévisionnel",
        pedestrians: "visiteurs",
        pedestrian: "visiteur",
        any: "aucun",
        tooltipTitlePrefix: "À :",
      },
      slider: {
        title: "Jauge d'occupation",
        capacity: "{capacity} visiteurs",
      },
      map: {
        reloadStatsOnZone: "Recharger les données sur la zone",
      },
    },
    nonMovingCarsScene: {
      title: "Contrôles",
      table: {
        header: {
          address: "Adresse",
          arrived: "Arrivée",
          time: "Temps",
          areaType: "Type de place",
        },
      },
    },
    analysisScene: {
      title: "Rapports d'analyses",
      hebdo: "Rapports Hebdo",
      monthly: "Rapports Mensuels",
      noReport: "Aucun rapport disponible",
    },
    flowScene: {
      infoTooltipMaximumDuration: "Données des temps de parcours <= {duration}",
      filters: {
        selectLabel: "Catégorie",
        date: {
          start: "Début",
          end: "Fin",
        },
        flowTypes: {
          car: "Véhicules légers",
          delivery: "Véhicules de livraison",
          two_wheeler: "2 roues",
          pedestrian: "Visiteurs",
          truck: "Camions",
          bus: "Bus",
          bicycle: "Vélos",
          motor_bike: "Motos",
          all_vehicles: "Tous les véhicules",
        },
      },
      flowType: {
        car: "{count, plural, one {véhicule léger} other {véhicules légers}}",
        two_wheeler: "deux roues",
        delivery:
          "{count, plural, one {véhicule de livraison} other {véhicules de livraison}}",
        pedestrian: "{count, plural, one {visiteur} other {visiteurs}}",
        truck: "{count, plural, one {camion} other {camions}}",
        bus: "bus",
        bicycle: "{count, plural, one {vélo} other {vélos}}",
        motor_bike: "{count, plural, one {moto} other {motos}}",
        all_vehicles: "{count, plural, one {véhicule} other {véhicules}}",
        short_car: "Voit.",
        short_two_wheeler: "2 roues",
        short_delivery: "Livr.",
        short_pedestrian: "Visiteurs",
        short_truck: "Camions",
        short_bus: "Bus",
        short_bicycle: "Vélos",
        short_motor_bike: "Motos",
        short_all_vehicles: "Véhi.",
      },
      flowSection: {
        title: {
          default: "Flux - {name}",
          path: "Temps de parcours - {name}",
          traffic: "Zone de traffic - {name}",
        },
        subtitle: "du {from} au {to}",
        comparedSubtitle: "Comparaison: {from} au {to}",
        statsRow: {
          numberOfPassages: "Nombre de passages",
          speedAvg: "Vitesse moyenne",
          in: "Entrées",
          out: "Sorties",
          travelTimeAvg: "Durée moyenne",
          travelTimeMedian: "Durée médiane",
          lessThanOneMinute: "< 1min",
          generalStats: {
            in: "{count, plural, one {Entrée} other {Entrées}}",
            out: "{count, plural, one {Sortie} other {Sorties}}",
          },
          maxStats: {
            in: "{count, plural, one {entrée} other {entrées}}",
            out: "{count, plural, one {sortie} other {sorties}}",
            at: "entre {hourStart} et {hourEnd}",
            the: "le {day}",
            max: "max",
          },
          infos: {
            in: "Période sélectionée (= 1 journée) :<br>Moyenne journalière sur les jours similaires<br><br>Période sélectionée (> 1 journée) :<br>Moyenne journalière sur la période sélectionnée",
            out: "Période sélectionée (= 1 journée) :<br>Moyenne journalière sur les jours similaires<br><br>Période sélectionée (> 1 journée) :<br>Moyenne journalière sur la période sélectionnée",
          },
          traffic: {
            fluid: "Fluide",
            loaded: "Chargé",
            saturated: "Saturé",
            fault: "Indéfini",
          },
        },
      },
      pathDistribution: {
        title: "Répartition temps de parcours",
        traffic: "{count, plural, one {passage} other {passages}}",
      },
      travelTime: {
        title: {
          hour: "Temps de parcours par heure",
          "5min": "Temps de parcours à 5 minutes",
        },
      },
      inOutDistribution: {
        title: "Répartition {in} / {out}",
        linePercentageTitle: "{in} / {out}",
        in: "Entrées",
        out: "Sorties",
        expandableStats: {
          header2: "du flux",
          content: "de {type}",
        },
        byValue: "Valeur",
        byPercentage: "Pourcentage",
      },
      charts: {
        attendance: {
          title: "Nombre de comptages",
          realTime: "Temps réel",
          previsional: "Prévisionnel",
          any: "aucun",
          tooltipTitlePrefixAt: "À :",
          noData: "Pas de donnée",
          tooltipTitlePrefixThe: "Le :",
          counts: "comptages",
          count: "comptage",
        },
        chronology: {
          title: "Chronologie",
          total: "Cumulé",
        },
        categoryCount: {
          title: "Nombre de comptages par catégorie",
        },
        traffic: {
          title: "Charge du traffic",
        },
      },
      traffic: {
        fluid: "Fluide",
        loaded: "Chargé",
        saturated: "Saturé",
        fault: "Indéfini",
      },
    },
    displaysScene: {
      noSelectedLayerInfo: "Veuillez sélectionner un panneau sur la carte",
      currentDisplayData: "Affichage actuel du panneau",
      currentDisplayEdit: "Configuration",
      runningMode: "Dernière mise à jour il y a",
      standbyMode: "En veille depuis",
      standbyForced: "Forcer la mise en veille",
      emergencyRuleForced: "Forcer la règle d'urgence",
      emergencyRuleTooltip:
        "Vous ne pouvez pas activer la règle d'urgence. Veuillez contacter le support si nécessaire.",
      save: "Enregistrer",
      mirrorAlert:
        "Miroir : les changements seront appliqués au panneau miroir",
      picto: "Pictogramme",
      ruleForced: "Règle d'affichage",
      color: "Couleur",
      text: "Texte",
      customText: "Texte personnalisé",
      other: "Autre...",
      ruleDisabledTooltip:
        "Veuillez désactiver le mode veille pour modifier la valeur",
      awolMessage: "Configuration indisponible, panneau injoignable",
      colors: {
        yellow: "Jaune",
        red: "Rouge",
        green: "Vert",
        "fade green yellow red": "Dégradé vert - jaune - rouge",
        "fade red yellow green": "Dégradé rouge - jaune - vert",
      },
      pictoColors: {
        green: "Flèche verte",
        red: "Croix rouge",
      },
      dialog: {
        title: "Confirmation de modification du panneau",
        content: "{type} du panneau",
        standbyForced: "Forcer la mise en veille du panneau",
        standbyRemoved: "Désactiver la mise en veille panneau",
        ruleRemoved: "Désactiver ma règle d'affichage",
        ruleForced: "Activer ma règle d'affichage à {text} en {color}",
        pictogramRuleForced: "et forcer le pictogramme à {text}",
        emergencyRuleRemoved: "Désactiver la règle d'urgence",
      },
    },
    customAnalysisScene: {
      title: "Analyse personnalisée",
      updatePeriod: "Modifier",
      filters: {
        analysisPeriod: "Période d'analyse",
        analysisAreaGroups: {
          title: "Type de zones analysées",
          car: "véhicule",
          cars: "véhicules",
          pedestrian: "visiteur",
          pedestrians: "visiteurs",
          capacity: "Capacité",
        },
        withComparaison: "Comparer",
        comparedToPeriod: "Comparé à la période",
        analyzedAreas: "Zones analysées",
        date: {
          start: "du",
          end: "au",
        },
        comparedP: "comparer",
      },
      sections: {
        dowAttendance: {
          title: "Affluence moyenne par jour de la semaine",
          analysis: "Affluence moyenne",
          compared: "Comparaison",
          tooltip:
            "Nombre de véhicules comptabilisés sur une journée (ex : 100 véhicules le lundi, 200 véhicules le mardi, etc.)",
        },
        dowPressure: {
          title: "Tension moyenne par jour de la semaine",
          analysis: "Tension moyenne",
          compared: "Comparaison",
          tooltip:
            "Taux d'occupation du parking moyen journalier sur la période (ex : 21% le lundi, 32% le mardi, etc.)",
        },
        attendance: {
          title: "Affluence",
          analysis: "Affluence",
          compared: "Comparaison",
          allTimeAverage: "Moyenne historique",
          allTimeRecord: "Record historique",
          tooltip: "Affluence totale journalière sur la période",
        },
        attendancePeak: {
          title: "Pic d'affluence horaire",
          analysis: "Pic d'Affluence horaire",
          compared: "Comparaison",
          allTimeAverage: "Moyenne historique",
          allTimeRecord: "Record historique",
          capacity: "Capacité",
          tooltip: "Nombre maximum de véhicules comptabilisés sur une heure",
        },
        hourlyAttendance: {
          title: "Temps de stationnement par heure",
          analysis: "Temps de stationnement par heure",
          compared: "Comparaison",
          allTimeAverage: "Moyenne historique",
          allTimeRecord: "Record historique",
          tooltip:
            "Temps moyen de stationnement comptabilisé à l'heure du départ des véhicules (ex : les véhicules partis à 20h sont restés en moyenne 3h10)",
          customSelector: {
            label: "Période de temps",
            weekEnd: "Week-end",
            workingDays: "Jours ouvrés",
            all: "Tous",
          },
        },
        statsRow: {
          the: "le {day}",
          theAt: "le {day} à {hour}",
          avgAttendance: {
            label: "Affluence moyenne journalière sur la période",
          },
          recordAttendance: {
            label: "Affluence record journalière sur la période",
          },
          recordPeakAttendance: {
            label: "Pic d’affluence record horaire sur la période",
          },
        },
      },
    },
    indicatorsScene: {
      title: "Indicateurs",
      showMap: "Afficher la carte",
      hideMap: "Masquer la carte",
      filters: {
        from: "Du",
        to: "Au",
      },
      table: {
        header: {
          cars: "Véhicules",
          delivery_vans: "Véhicules de livraison",
          trucks: "Camions",
          bus: "Bus",
          two_wheelers: "2 roues",
          pedestrians: "Visiteurs",
          charging: "Véhicules électriques",
        },
      },
      modal: {
        btnDownload: "Télécharger les données",
        title: "Télécharger les données du {from} au {to}",
        selectIndicators:
          "Sélectionnez les indicateurs que vous souhaitez télécharger :",
        selectCategories:
          "Sélectionnez les catégories que vous souhaitez télécharger :",
        fileFormat: "Format du fichier :",
        download: "Télécharger",
        totalData: "Données totales sur la période",
        dailyData: "Données par jour sur la période",
        hourlyData: "Données par heure sur la période",
      },
    },
    visitorCharacteristicsScene: {
      title: "ID A UPDATE: customAnalysisScene.title",
      filters: {
        area: "Zone",
      },
      sections: {
        qualificationIndicators: {
          title: "Statistiques visiteurs",
          visitorOnSite: "visiteurs sur le site",
          singleVisitorOnSite: "visiteurs uniques sur le site",
          bounce: "Taux de rebond <{bounceValue} min",
          visitorOnSiteTooltip:
            "Nombre total de véhicules comptabilisés sur la période",
          singleVisitorOnSiteTooltip:
            "Nombre de véhicules uniques comptabilisés sur la période (basé sur la correspondance de la plaque d'immatriculation)",
          bounceTooltip:
            "Nombre de véhicules ayant fait un passage rapide sur le parking sur la période",
        },
        qualificationVisitors: {
          title: "Répartition visiteurs",
          newVisitors: "Nouveaux visiteurs",
          knownVisitors: "Visiteurs connus",
          daily: "Visiteurs quotidiens",
          monthly: "Visiteurs mensuels",
          weekly: "Visiteurs hebdos",
          yearly: "Visiteurs annuels",
        },
        qualificationTime: {
          title: "Répartition temps de stationnement",
          byhour: "Temps de stationnement par heure",
          infoTooltip: "Données de durée de stationnement <= {duration}",
          destinationInfoTooltip:
            "Données de durée de stationnement >= {duration}",
        },
        qualificationDestination: {
          title: "Zones de destination",
        },
        qualificationCatchmentAreas: {
          title: "Zone de chalandise",
          nbConnection: "{nb_connections} connexions",
          fromApp:
            "Données issues de l'application mobile entre le {from} et le {to}",
        },
      },
    },
    configSectorsScene: {
      title: "Configuration par secteur",
      save: "Modifier",
      labels: {
        type: "Type",
        value: "Valeur",
      },
      types: {
        cars: "Nombre de véhicules",
        spots: "Nombre de places libres",
        capacity: "Capacité totale",
        pedestrian: "Nombre de visiteurs",
      },
      dialog: {
        cancel: "Annuler",
        confirm: "Oui je suis sûr",
        title: "Confirmation de modification du secteur",
        content: "Modifier {type} de {old} à {value} ?",
        types: {
          cars: "le nombre de véhicules",
          spots: "le nombre de place libres",
          capacity: "la capacité totale",
          pedestrians: "le nombre de visiteurs",
        },
      },
    },
    alertsScene: {
      title: "Alertes",
      totalEvents: "Nombre d'alertes : {count}",
      search: "Rechercher",
      filters: {
        from: "Du",
        to: "Au",
        rule: "Règle",
        alertPolicies: "Alerte",
        outputTypes: "Notification",
      },
      instant: "À l'instant",
      minutes: "Il y a {minutes} min",
      hours: "Il y a {hours}h",
      rules: {
        TRAVEL_TIME_THRESHOLD_EXCEEDED: "Temps de parcours dépassé",
        TRAFFIC_CONGESTION: "Congestion de trafic",
        AUTOMATIC_SYSTEMS_GATE_MODE_CHANGED:
          "Modification du mode de la barrière",
        PARKING_FILLED: "Le parking a dépassé un seuil d'occupation",
        AUTOMATIC_SYSTEMS_GATE_COUNTER_INCREMENTED:
          "Remontée d'alerte de la barrière",
        AUTOMATIC_SYSTEMS_GATE_DISCONNECTED: "Barrière déconnectée",
        AUTOMATIC_SYSTEMS_GATE_RECONNECTED: "Barrière reconnectée",
      },
      outputTypes: {
        BO: "Hyperviseur",
        BO_TOAST: "Hyperviseur (Live)",
      },
      modal: {
        closeAlert: "Fermer l'alerte",
        noMessage: "Aucun message disponible",
        createdAt: "Date de détection",
        closeAutomatically: "Fermeture automatique dans {timeLeft}s",
        alertNumber: "Alerte {number}",
        markAllAsRead:
          "{count, plural, one {Marquer l'alerte comme lue} other {Marquer toutes les alertes comme lues}}",
      },
      managementModal: {
        title: "Gestion des alertes",
        enableMAIL: "Activer les notifications par email",
        policyIsDisabled: "L'alerte est désactivée",
        outputIsDisabled: "Cette notification d'alerte est désactivée",
      },
    },
    automaticSystemsScene: {
      loading: "Chargement...",
      mode: "Mode",
      status: "Statut",
      modes: {
        AUTO: "Automatique",
        FREE: "Libre Accès",
        BLOP: "Bloqué Ouvert",
        BLCL: "Bloqué Fermé",
      },
      statusValues: {
        open: "Ouvert",
        closed: "Fermé",
        moving: "En mouvement",
      },
      form: {
        forceStatus: "Forcer le statut",
        selectStatus: "Sélectionner le statut",
        operationMode: "Mode de fonctionnement",
        selectMode: "Sélectionner le mode",
        validate: "Valider",
        open: "Ouvrir",
        close: "Fermer",
        enableEmergency: "Activer le mode d'urgence",
        disableEmergency: "Désactiver le mode d'urgence",
      },
      error: {
        cannotRetrieveInfo: "Impossible de communiquer avec la barrière",
      },
      toast: {
        statusChanged: "Changement de statut réalisé avec succès",
        modeChanged: "Changement de mode réalisé avec succès",
      },
    },
  },
};

export default fr;
